module.exports = __webpack_public_path__ + "static/media/galerija_2021 (31).c1ae4bfb.jpg";